import { createRouter, createWebHistory } from "vue-router";
import HomeView from "./views/en/HomeEn.vue";
const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
    meta: {
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/about/en",
    name: "About",
    component: () => import("./views/en/AboutView.vue"),
    meta: {
      testimoniosusuaiosEn: true,
      menuEs: true,
      contactformEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/Blog/en",
    name: "Blog",
    component: () => import("./views/en/BlogView.vue"),
    meta: {
      testimoniosusuaiosEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/service",
    name: "Service",
    component: HomeView,
    meta: {
      title: "PSOFNTECH - HOME",
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/service/sub/LaptopRepair/:rout/en",
    name: "Laptop Repair",
    component: () => import("./views/en/LaptopRepair.vue"),
    meta: {
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
      contactformEn: true,
    },
  },
  {
    path: "/service/sub/DigitalMarketing/:rout/en",
    name: "Digital Marketing",
    component: () => import("./views/en/DigitalMarketing.vue"),
    meta: {
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
      contactformEn: true,
    },
  },
  {
    path: "/service/OnsiteComputerRepair/en",
    name: "OnsiteComputerRepair",
    component: () => import("./views/en/OnsiteComputerRepair.vue"),
    meta: {
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      contactformEn: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/service/WebDesign/en",
    name: "Web Design",
    component: () => import("./views/en/WebDesing.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/service/AppDevelopment/en",
    name: "App Development",
    component: () => import("./views/en/AppDevelopment.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/service/MerchantServices/en",
    name: "Merchant Services",
    component: () => import("./views/en/MerchantServices.vue"),
    meta: {
      menuEs: true,
      contactformEs: true,
      contactformEn: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/service/:type/en",
    name: "Services",
    component: () => import("./views/en/ServiceView.vue"),
    meta: {
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      contactformEn: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/service/sub/GraphicDesign/:rout/en",
    name: "Service Graphic Design",
    component: () => import("./views/en/SubGraphics.vue"),
    meta: {
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
      contactformEn: true,
    },
  },
  {
    path: "/service/sub/:type/en",
    name: "Cards",
    component: () => import("./views/en/WithCards.vue"),
    meta: {
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
      contactformEn: true,
    },
  },
  {
    path: "/service/sub/:type/:rout/en",
    name: "Ruta1",
    component: () => import("./views/en/SubServices.vue"),
    meta: {
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
    },
  },
  /*----------------PARTE Spanish--------------------------------------- */
  {
    path: "/about/es",
    name: "About Es",
    component: () => import("./views/es/HomeEs.vue"),
    meta: {
      layout: "LayoutEs",
      title: "PSOFNTECH - INICIO",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },
  {
    path: "/resource/es",
    name: "Resource Es",
    component: () => import("./views/es/HomeEs.vue"),
    meta: {
      layout: "LayoutEs",
      title: "PSOFNTECH - INICIO",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },
  {
    path: "/Blog/es",
    name: "EsBlog",
    component: () => import("./views/es/BlogViewEs.vue"),
    meta: {
      layout: "LayoutEs",
      testimoniosusuaiosEs: true,
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },
  {
    path: "/es",
    name: "EsHome",
    component: () => import("./views/es/HomeEs.vue"),
    meta: {
      layout: "LayoutEs",
      title: "PSOFNTECH - INICIO",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },
  {
    path: "/service",
    name: "Service Spanish",
    component: () => import("./views/es/HomeEs.vue"),
    meta: {
      layout: "LayoutEs",
      title: "PSOFNTECH - INICIO",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },

  {
    path: "/service/sub/:type/es",
    name: ":type",
    component: () => import("./views/es/WithCardsEs.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
      contactformEs: true,
    },
  },
  {
    path: "/service/OnsiteComputerRepair/es",
    name: "OnsiteComputerRepairEs",
    component: () => import("./views/es/OnsiteComputerRepairEs.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      contactformEs: true,
      piepaginaEn: true,
    },
  },
  {
    path: "/service/WebDesign/es",
    name: "WebDesign2ES",
    component: () => import("./views/es/WebDesingEs.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },
  {
    path: "/service/AppDevelopment/es",
    name: "App2ES",
    component: () => import("./views/es/AppDevelopmentEs.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },
  {
    path: "/service/MerchantServices/es",
    name: "MerchaES",
    component: () => import("./views/es/MerchantServicesEs.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      contactformEs: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },
  {
    path: "/service/:type/es",
    name: "SimpleES",
    component: () => import("./views/es/ServiceViewEs.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      contactformEs: true,
      piepaginaEn: true,
    },
  },
  {
    path: "/service/sub/GraphicDesign/:rout/es",
    name: "RutaES",
    component: () => import("./views/es/SubGraphicsEs.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
      contactformEs: true,
    },
  },

  {
    path: "/service/sub/:type/:rout/es",
    name: "Ruta1Es",
    component: () => import("./views/es/SubServicesEs.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
    },
  },

  /*----------------PARTE BACKK--------------------------------------- */
  {
    path: "/login",
    name: "login",
    component: () => import("./views/CMS/LoginView.vue"),
    meta: {
      layout: "LoginLayout",
      title: "PSOFNTECH - LOGIN",
    },
  },
  {
    path: "/users",
    name: "User",
    component: () => import("./views/CMS/UsersView.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - USERS",
    },
  },
  {
    path: "/pages",
    name: "Pages CMS",
    component: () => import("./views/CMS/PagesView.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PORTFOLIO",
    },
  },

  {
    path: "/pages/:id",
    name: "Page",
    component: () => import("./views/CMS/PageView.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PAGE",
    },
  },

  {
    path: "/testimonials",
    name: "Testimonials",
    component: () => import("./views/CMS/Testimonial/TestimonialView.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - TESTIMOANIALS",
    },
  },

  {
    path: "/testimonial-create",
    name: "Create Testimonial",
    component: () => import("./views/CMS/Testimonial/components/CreateComponent.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - TESTIMONIAL"
    }
  },

  {
    path: "/testimonial-edit/:id",
    name: "Update Testimonial",
    component: () => import("./views/CMS/Testimonial/components/EditComponent.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - TESTIMONIAL"
    }
  },

  {
    path: "/site",
    name: "Site",
    component: () => import("./views/CMS/SiteView/ContactInfo.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - CONTACT",
    },
  },
  {
    path: "/site/SEO",
    name: "Site-SEO",
    component: () => import("./views/CMS/SiteView/SeoInfo.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - SEO",
    },
  },
  {
    path: "/site/general-configuration",
    name: "Configuration",
    component: () => import("./views/CMS/SiteView/GeneralConfig.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - CONFIGURATION",
    },
  },
  {
    path: "/site/Contact",
    name: "Contact",
    component: () => import("./views/CMS/SiteView/ContactInfo.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - CONTACT",
    },
  },
  {
    path: "/site/Banner",
    name: "Banner",
    component: () => import("./views/CMS/SiteView/BannerIndex.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - BANNER",
    },
  },
  {
    path: "/site/BannerSubServicios",
    name: "Parallax",
    component: () => import("./views/CMS/SiteView/BannerSubServicios.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - BANNER",
    },
  },
  {
    path: "/site/Business",
    name: "Business",
    component: () => import("./views/CMS/SiteView/BusinessInfo.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - BUSINESS",
    },
  },
  {
    path: "/portfolio",
    name: "Portafolios",
    component: () => import("./views/CMS/Portfolio/PortfolioTable.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PAGES",
    },
  },
  {
    path: "/portfolio/:rout",
    name: "Portfolios",
    component: () => import("./views/CMS/Portfolio/PortfolioTable.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PORTFOLIOS",
    },
  },
  {
    path: "/portfolio/:rout/:id",
    name: "Portfolio",
    component: () => import("./views/CMS/Portfolio/PortfolioView.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PORTFOLIOS",
    },
  },
  {
    path: "/blogCMS",
    name: "Blogs CMS",
    component: () => import("./views/CMS/Blog/Blogs.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PORTFOLIO",
    },
  },
  {
    path: "/blogCMS/:id",
    name: "Blog CMS",
    component: () => import("./views/CMS/Blog/Blog.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PORTFOLIO",
    },
  },
  {
    path: "/aboutCMS",
    name: "About US CMS",
    component: () => import("./views/CMS/About/AboutUS.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - ABOUT US",
    },
  },
  {
    path: "/servicescms",
    name: "Services CMS",
    component: () => import("./views/CMS/Servicios/PackagesTable.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PORTFOLIO",
    },
  },
  {
    path: "/servicescms/Package",
    name: "Package",
    component: () => import("./views/CMS/Servicios/PackagesTable.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PORTFOLIO",
    },
  },
  {
    path: "/servicescms/Package/:id",
    name: "Package Edit",
    component: () => import("./views/CMS/Servicios/PackageView.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PORTFOLIO",
    },
  },
  {
    path: "/servicescms/services",
    name: "All Services",
    component: () => import("./views/CMS/Servicios/ServiciosView.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - PORTFOLIO",
    },
  },
  {
    path: "/menu",
    name: "Menu",
    component: () => import("./views/CMS/Menu/MenuView.vue"),
    meta: {
      layout: "DashboardView",
      title: "PSOFNTECH - MENU",
    },
  },


  /* added as of 10/18/22 */

  {
    path: "/webdesign/ny/ridgewood/queens/en",
    name: "Web Design | New York (NY) | RIDGEWOOD, QUEENS",
    component: () => import("./views/en/address/WebDesingRIDGEWOOD-QUEENS.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/webdesign/ny/ridgewood/queens/es",
    name: "Diseño Web | New York (NY) | RIDGEWOOD, QUEENS",
    component: () => import("./views/es/address/WebDesingRIDGEWOOD-QUEENS-es.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },
  
  {
    path: "/webdesign/ny/glendale/queens/en",
    name: "Web Design | New York (NY) | GLENDALE, QUEENS",
    component: () => import("./views/en/address/WebDesingGLENDALE-QUEENS.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/webdesign/ny/glendale/queens/es",
    name: "Diseño Web | New York (NY) | GLENDALE, QUEENS",
    component: () => import("./views/es/address/WebDesingGLENDALE-QUEENS-es.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },
  {
    path: "/webdesign/ny/maspeth/queens/en",
    name: "Web Design | New York (NY) | MASPETH, QUEENS",
    component: () => import("./views/en/address/WebDesingMASPETH-QUEENS.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/webdesign/ny/maspeth/queens/es",
    name: "Diseño Web | New York (NY) | MASPETH, QUEENS",
    component: () => import("./views/es/address/WebDesingMASPETH-QUEENS-es.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },

  {
    path: "/webdesign/ny/laurel-hill/queens/en",
    name: "Web Design | New York (NY) | Laurel Hill, QUEENS",
    component: () => import("./views/en/address/WebDesingLaurelHill-QUEENS.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/webdesign/ny/laurel-hill/queens/es",
    name: "Diseño Web | New York (NY) | Laurel Hill, QUEENS",
    component: () => import("./views/es/address/WebDesingLaurelHill-QUEENS-es.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },

  {
    path: "/webdesign/ny/middle-village/queens/en",
    name: "Web Design | New York (NY) | Middle Village, QUEENS",
    component: () => import("./views/en/address/WebDesingMiddleVillage-QUEENS.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/webdesign/ny/middle-village/queens/es",
    name: "Diseño Web | New York (NY) | Middle Village, QUEENS",
    component: () => import("./views/es/address/WebDesingMiddleVillage-QUEENS-es.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },

  {
    path: "/webdesign/ny/blissville/queens/en",
    name: "Web Design | New York (NY) | Blissville, QUEENS",
    component: () => import("./views/en/address/WebDesingBlissville-QUEENS.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/webdesign/ny/blissville/queens/es",
    name: "Diseño Web | New York (NY) | Blissville, QUEENS",
    component: () => import("./views/es/address/WebDesingBlissville-QUEENS-es.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },

  {
    path: "/webdesign/ny/corona-east-elmhurst/queens/en",
    name: "Web Design | New York (NY) | Corona East Elmhurst, QUEENS",
    component: () => import("./views/en/address/WebDesingCoronaEastElmhurst-QUEENS.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/webdesign/ny/corona-east-elmhurst/queens/es",
    name: "Diseño Web | New York (NY) | Corona East Elmhurst, QUEENS",
    component: () => import("./views/es/address/WebDesingCoronaEastElmhurst-QUEENS-es.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },

  {
    path: "/webdesign/ny/elmhurst/queens/en",
    name: "Web Design | New York (NY) | Elmhurst, QUEENS",
    component: () => import("./views/en/address/WebDesingElmhurst-QUEENS.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/webdesign/ny/elmhurst/queens/es",
    name: "Diseño Web | New York (NY) | Elmhurst, QUEENS",
    component: () => import("./views/es/address/WebDesingElmhurst-QUEENS-es.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },

  {
    path: "/webdesign/ny/jackson-heights/queens/en",
    name: "Web Design | New York (NY) | Jackson Heights, QUEENS",
    component: () => import("./views/en/address/WebDesingJacksonHeights-QUEENS.vue"),
    meta: {
      contactformEn: true,
      menuEs: true,
      contactformEs: true,
      testimoniosusuaiosEs: true,
      piepaginaEs: true,
    },
  },
  {
    path: "/webdesign/ny/jackson-heights/queens/es",
    name: "Diseño Web | New York (NY) | Jackson Heights, QUEENS",
    component: () => import("./views/es/address/WebDesingJacksonHeights-QUEENS-es.vue"),
    meta: {
      layout: "LayoutEs",
      menuEn: true,
      contactformEn: true,
      testimoniosusuaiosEn: true,
      piepaginaEn: true,
    },
  },
  /* / added as of 6/14/24 */

  {

  },

  /* / added as of 10/18/22 */



  /*--------------END PARTE BACKKK----------------------------------------- */
  {
    path: "/:pathMatch(.*)*/",
    name: "404",
    component: HomeView,
    meta: {
      auth: true,
      title: "PSOFNTECH - 404",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // document.title = `${to.params.type}`;
  window.scroll({
    top: 0,
    behavior: "smooth",
  });
  next();
});

export default router;
